const FETCH_FAMILY_MEMBERS_REQUEST = "FETCH_FAMILY_MEMBERS_REQUEST";
const FETCH_FAMILY_MEMBERS_SUCCESS = "FETCH_FAMILY_MEMBERS_SUCCESS";
const FETCH_FAMILY_MEMBERS_FAILURE = "FETCH_FAMILY_MEMBERS_FAILURE";

export default {
  FETCH_FAMILY_MEMBERS_REQUEST,
  FETCH_FAMILY_MEMBERS_SUCCESS,
  FETCH_FAMILY_MEMBERS_FAILURE,
};
